import { useMutation } from '@tanstack/react-query';

import type { MutationResponse, UserFormData } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useToggleUserLockMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request({
        method: 'PUT',
        url: `${params.url}/${params.id}/lock`,
      }),
  });

export const useUserFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: UserFormData;
    }) =>
      HttpClient.request<MutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
